const slickCarousel = require('slick-carousel');
window.slick = slickCarousel;

$(".slider").each(function () {
    var $this = $(this);
    var slideConfig = $this.data('slick');
    slideConfig.prevArrow = `<button type="button" class="slick-prev"><div class="icon icon-angle-left --icon-light "><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Size=L, Fill=Off, Direction=West"><path id="Union" d="M28.05 36.6785L15.3215 23.95L28.05 11.2215L30.8785 14.05L20.9785 23.95L30.8785 33.85L28.05 36.6785Z" fill="#0A0A0A"></path></g></svg></div></button>`
    slideConfig.nextArrow = `<button type="button" class="slick-next"><div class="icon icon-angle-left --icon-light "><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Size=L, Fill=Off, Direction=East"><path id="Union" d="M25.8215 23.95L15.9215 14.05L18.75 11.2215L31.4785 23.95L18.75 36.6785L15.9215 33.85L25.8215 23.95Z" fill="#0A0A0A"></path></g></svg></div></button>`
    slideConfig = {
        ...{
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }, ...slideConfig
    };

    $this.slick(slideConfig);
});